import { LanguageAttributes } from "../attributes/language-attributes";

class Language {
  designation: string;

  constructor(designation: string) {
    this.designation = designation;
  }

  static fromJson(json: LanguageAttributes) {
    if (json === null || json === undefined) {
      return null;
    }

    return new Language(json.designation);
  }
}

export default Language;
